import { FormControl, FormLabel, Input, FormErrorMessage, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
const CountryField = ({ value, onChange, error }) => {
  const labelColor = useColorModeValue('black', 'white');
  const { darkMode } = useSelector((state) => state.settings);
  return (
    <FormControl isInvalid={!!error} isRequired>
      <Tooltip label="Select the country for this rate." placement="top">
        <FormLabel color={darkMode ? 'white' : 'black'}>Country</FormLabel>
      </Tooltip>
      <Input
        name="country"
        value={value}
        onChange={onChange}
        placeholder="Country"
        style={{
          background: darkMode ? '#1e2021' : 'white',

           color: `${darkMode ? '#f5f4f3' : 'inherit'}`,
          borderColor: `${darkMode ? '#565557' : '#007bff'}`
        }}
      />
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default CountryField;
